import feedTemplate from '../tasks-feed/tasks.feed.html';
import taskCard from './task-card/taskCard';
import toastWrapperService from './toast-wrapper-service/toastWrapperService';
import refineTasks from './filters/refineTasks';
import explainer from './explainer/refineTasksExplainer';
import sort from './task-sort/refineTaskSort';

const module = angular.module('websked.tasks.search', []);

const toLoad = [
  taskCard,
  toastWrapperService,
  refineTasks,
  explainer,
  sort
];

toLoad.forEach(fn => fn(module));

function taskSearchRoute($stateProvider) {
  $stateProvider
    .state('tasks.taskList', {
      url: '?ts&createdBy',
      params: {
        ts: {
          array: true
        }
      },
      controller: 'TasksFeedController',
      template: feedTemplate,
      resolve: {
        entity() {
          return { type: 'all' };
        }
      },
      data: {
        pageTitle: {
          de: 'Aufgaben',
          en: 'Tasks',
          es: 'Tareas',
          fr: 'Tâches'
        }
      }
    })
    .state('tasks.mine', {
      url: '/mine?ts',
      params: {
        ts: {
          array: true
        }
      },
      controller: 'TasksFeedController',
      template: feedTemplate,
      resolve: {
        entity: [
          'LoggedInUser',
          LoggedInUser => ({ type: 'user', id: LoggedInUser.username })
        ]
      },
      data: {
        pageTitle: {
          de: 'Meine Aufgaben',
          en: 'My Tasks',
          es: 'Mis Tareas',
          fr: 'Mes Tâches'
        }
      }
    });
}

module.config(['$stateProvider', taskSearchRoute]);
